import { blankIds, track } from "../lib/track_usage"

// Declarative tracking: <button data-track="event_name" data-track-props='{"k":"v"}'>.
// Dropdown and popover toggles log on Bootstrap's open event (a click on the
// toggle also closes it); everything else logs on click.
const TOGGLE = "[data-bs-toggle='dropdown'], [data-controller~='popover']"

const fire = event => {
  const element = event.target.closest?.("[data-track]")
  if (!element) return

  let props = {}
  try { props = JSON.parse(element.dataset.trackProps || "{}") } catch { }
  track(element.dataset.track, props)
}

document.addEventListener("show.bs.dropdown", fire)
document.addEventListener("shown.bs.popover", fire)
document.addEventListener("click", event => {
  if (event.target.closest?.("[data-track]")?.matches(TOGGLE)) return
  fire(event)
})

// Menu picks: one delegated listener for every Bootstrap dropdown item.
// `item` is the link's path with ids blanked. An item that goes nowhere
// (href="#": a modal trigger, a clipboard copy) or a <button> has no path,
// so it opts in with data-track-item, or is named by the modal it opens.
// Elements with data-track already log above.
document.addEventListener("click", event => {
  const element = event.target.closest?.(".dropdown-menu .dropdown-item")
  if (!element || element.matches("[data-track]")) return

  const href = element.getAttribute("href")
  const navigates = href && !href.startsWith("#") && !href.startsWith("javascript:")
  const item = navigates ? blankIds(new URL(href, location.href).pathname) : (element.dataset.trackItem || element.dataset.bsTarget)
  if (!item) return

  const method = element.dataset.turboMethod || element.dataset.method
  track("menu_item_picked", method ? { item, method } : { item })
})
